import { useState } from "react";
import { Package } from "lucide-react";
import { imgUrl } from "@/lib/api";

export const ProductGallery = ({ images = [], name }) => {
  const [active, setActive] = useState(0);
  const main = images[active] || images[0];
  return (
    <div>
      <div className="aspect-square overflow-hidden rounded-3xl bg-brand-tint ring-1 ring-slate-200">
        {main ? (
          <img src={imgUrl(main.url)} alt={main.alt || name} width="1600" height="1600" className="h-full w-full object-cover" data-testid="gallery-main-image" />
        ) : (
          <div className="flex h-full items-center justify-center text-slate-500"><Package className="h-12 w-12" aria-hidden="true" /></div>
        )}
      </div>
      {images.length > 1 && (
        <div className="mt-4 flex gap-3 overflow-x-auto pb-1 no-scrollbar">
          {images.map((im, idx) => (
            <button
              type="button"
              key={im.url}
              onClick={() => setActive(idx)}
              aria-label={`Show image ${idx + 1} of ${images.length}`}
              aria-pressed={idx === active}
              data-testid={`gallery-thumb-${idx}`}
              className={`h-20 w-20 shrink-0 overflow-hidden rounded-2xl ring-2 transition-[box-shadow] ${idx === active ? "ring-brand-greenDark" : "ring-slate-200 hover:ring-slate-300"}`}
            >
              <img src={imgUrl(im.thumb || im.url)} alt="" loading="lazy" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
